import React, { Component } from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import moment from '~/Providers/Moment';

import { DATE_TIME_FORMAT } from '~/Redux/Constants';
import { openPresetModal } from '~/Redux/Modules/Events';
import { findCalendarInList, mapCalendarsToList } from '~/Redux/Modules/CalendarAccounts';

import './MobileFAB.scss';
import { openModal, setModalData } from '~/Redux/Modules/Modal';
import { HABIT_CREATE_EDIT_MODAL } from '~/Config/Modals';

export class MobileFAB extends Component {
  handleMakeEvent = () => {
    const { openPresetModal, start, currentType } = this.props;
    const nowish = moment().round(30, 'minutes');
    let eventStart = nowish;
    if (!start.isSame(nowish, currentType)) {
      eventStart = moment([
        start.year(),
        start.month(),
        start.date(),
        nowish.hour(),
        nowish.minutes(),
        0,
      ]);
    }
    openPresetModal({
      start: eventStart.format(DATE_TIME_FORMAT),
      end: eventStart
        .clone()
        .add(1, 'hour')
        .format(DATE_TIME_FORMAT),
      color: this.props.defaultCalendar.color,
    });
  };

  handleMakeNewHabit = () => {
    const { dispatch } = this.props;
    dispatch(setModalData({ habit: null }));
    dispatch(openModal(HABIT_CREATE_EDIT_MODAL));
  };

  render() {
    const onClick = this.props.isHabit ? this.handleMakeNewHabit : this.handleMakeEvent;
    return (
      <div
        className={`mobile-fab ${this.props.isHabit ? 'habits-tab-fab' : ''}`}
        onClick={onClick}
      />
    );
  }
}

MobileFAB.propTypes = {
  openPresetModal: propTypes.func,
  start: propTypes.object,
  currentType: propTypes.string,
  defaultCalendar: propTypes.object,
  dispatch: propTypes.func,
  isHabit: propTypes.bool,
};

const mapStateToProps = ({ DateRange, UserOptions, CalendarAccounts }) => {
  return {
    start: DateRange.start,
    currentType: DateRange.currentType,
    defaultCalendar:
      findCalendarInList(mapCalendarsToList(CalendarAccounts), UserOptions.data.calendar_id) || {},
  };
};

const mapDispatchToProps = dispatch => {
  return {
    openPresetModal: update => dispatch(openPresetModal(update)),
    dispatch: dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileFAB);
